import { isPaperworkBypassed, isPaperworkCompleted } from '~/core/util/paperwork';
import { isPaperworkEnabled } from '~/core/util/location';

/**
 * Lists all possible booking states that drive copy changes on AppointmentCard
 *
 * ActiveBookingStates is a portmanteau:
 * Pre/In/Post: condensed booking status
 * Telemed/ClinicVisit: telemed or not
 * Complete/Incomplete/NAPaperwork: paperwork status
 * (NAPaperwork is used only if necessary how these states are currently being used; we default to complete even if the location doesnt have paperwork)
 * SummaryMissing/Pending/Downloadable/Updatable/Viewable: visit summary status
 * HasCheck/NoCheck: mobile check-in for clinic visits only
 * NoRating/HasRating: whether patient rated post-visit
 * Early/ApptSoon: proximity to upcoming appointment
 *
 * @enum {number}
 *
 */
export enum ActiveBookingStates {
  PreTelemedIncompleteAndEarly,
  PreTelemedIncompleteAndApptSoon,
  PreTelemedCompleteAndEarly,
  PreTelemedCompleteAndApptSoon,
  PreExternalTelemed,
  InTelemed,
  PostTelemedNoRating,
  PostTelemedHasRating,
  PostTelemedSummaryMissing,
  PostTelemedSummaryPending,
  PostTelemedSummaryDownloadable,
  PostTelemedSummaryUpdatable,
  PostTelemedSummaryViewable,
  PreClinicVisitHasCheckIncompleteAndEarly,
  PreClinicVisitHasCheckCompleteOrApptSoon,
  PreClinicVisitNoCheckIncomplete,
  PreClinicVisitNoCheckComplete,
  PreClinicVisitNoCheckNAPaperwork,
  InClinicVisit,
  PostClinicVisitNoRating,
  PostClinicVisitHasRating,
  PostVisitHasLabResult,
}

/**
 * Determine whether paperwork is completed or not applicable to the booking based on appointment and paperworkEnabled.
 *
 * @param {any} appointment - booking
 * @param {any} location - location
 * @returns boolean
 */

export const isPaperworkCompleteOrNotApplicable = (appointment: any, location: any) =>
  !isPaperworkEnabled(location) ||
  isPaperworkCompleted(appointment) ||
  isPaperworkBypassed(appointment);
